import styled from 'styled-components';

export const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const AnexosGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
`;

export const AnexoItem = styled.div`
  position: relative;
  border: none;
  border-radius: 8px;
  padding: 0;
  text-align: center;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ThumbButton = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  img {
    width: 100%;
    height: 90px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #ccc;
  }

  span {
    display: block;
    padding: 12px;
    font-size: 12px;
  }

  &:hover img {
    border-color: #9db1ff;
    box-shadow: 0 0 0 1px rgba(31, 58, 138, 0.15);
  }
`;

export const PdfPreview = styled.div`
  width: 100%;
  height: 90px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #c0392b;

  span {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.3px;
  }
`;

export const RemoveButton = styled.button`
  position: static;
  border: none;
  background: #e74c3c;
  color: #fff;
  border-radius: 0 8px 8px 0;
  width: 36px;
  height: 28px;
  padding: 0;
  cursor: pointer;
  font-weight: bold;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: currentColor;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background: #c0392b;
  }
`;

export const Caption = styled.div`
  margin-top: 6px;
  font-size: 12px;
  word-break: break-word;
  display: inline-flex;
  align-items: center;
  gap: 0;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
`;

export const ModalContent = styled.div`
  background: #fff;
  padding: 12px;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  max-width: 80vw;
  max-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 70vw;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 6px;
  }
`;

export const FileTag = styled.button`
  border: none;
  background: #eef2ff;
  color: #1f3a8a;
  padding: 5px 10px;
  border-radius: 6px 0 0 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  width: auto;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  white-space: nowrap;

  &:hover {
    background: #dfe8ff;
  }
`;

export const AddTagButton = styled.button`
  border: 1px dashed #9db1ff;
  background: #f4f6ff;
  color: #1f3a8a;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  line-height: 1;

  svg {
    fill: currentColor;
  }
`;
